export default __webpack_public_path__ + "static/media/carrot.f50368f5.svg";